module.exports = __webpack_public_path__ + "media/images/prismic_catalog/presentation_cards/categories/cleaning-b9c841fe988ed0e9f4e10f04f2a57b39.png";